import { useEffect, useState } from "react";
import useUserService from "../../services/UserService";
import { User } from "../../types/User";
import Ghost from "../Ghost";

export default function UserNameById({ userId }: { userId: string }) {

    // Load the user
    const [user, setUser] = useState<User | null>(null);

    const [userRetrieved, setUserRetrieved] = useState(false);

    const {getUser} = useUserService();

    const re = /^oculus_(.+)_(\d+)$/; // group 1 = username, group 2 = numeric id

    const getDisplayName = (user: User) => {
        if (!user) return "Unknown User";
        const match = re.exec(user.nickname);
        if (match) {
            return match[1]; // return the username
        }
        return user.nickname ?? user.email;
    };

    useEffect(() => {

        if (userRetrieved) return;

        setUserRetrieved(true);

        const fetchUser = async () => {
            const user = await getUser(userId);
            setUser(user);
        };

        fetchUser();
    }, [userId]);

    return (
        <>
            {user && <span>{getDisplayName(user)}</span>}
            {!user && <Ghost additionalClasses="h-4"  />}
        </>
    )
}